<template>
  <el-dialog
    title="修改密码"
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    append-to-body
    :before-close="closeDialog"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
      <el-form-item label="原密码" prop="oldPassword">
        <el-input v-model.trim="form.oldPassword" type="password" placeholder="请输入原密码" show-password />
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input v-model.trim="form.newPassword" type="password" placeholder="请输入新密码" show-password />
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input v-model.trim="form.confirmPassword" type="password" placeholder="请再次输入新密码" show-password />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="closeDialog">取 消</el-button>
      <el-button size="small" type="primary" :loading="loading" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { modifyPassword } from '@/api/system/user'
import { useInitUtil } from '@/utils/init';

export default {
  name: 'ModifyPassword',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 验证确认密码
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在6-20个字符之间', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    /**
     * 提交表单
     */
    submit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            await modifyPassword({
              pwd: this.form.oldPassword,
              pwd1: this.form.newPassword
            })
            this.$message.success('密码修改成功')
            this.closeDialog()
          } catch (error) {
            this.loading = false
          }
        }
      })
    },

    /**
     * 关闭对话框
     */
    closeDialog() {
      this.$emit('update:visible', false)
      setTimeout(() => {
        useInitUtil.init(this.form)
      }, 200)
      setTimeout(() => {
        this.$refs.form?.clearValidate()
      }, 400)
    }
  }
}
</script>
